import strategicFinance from '../../assets/strategicFinance.jpg';
import businessPartner from '../../assets/businessPartner.jpg';
import ai from '../../assets/ai.jpg';
import globalAdvisory from '../../assets/globalAdvisory.jpg';
import luciana from '../../assets/luciana.jpg';
import gabrielle from '../../assets/Gabrielle.jpg';
import gabriel from '../../assets/Gabriel.jpeg';


export const TEAM_DETAILS = {
  en: [
    {
      name: "Luciana Camargo",
      role: "CEO & Founder | Strategic CFO",
      bio: "CEO and Founder of Monetique, Luciana Camargo serves as a strategic CFO, helping businesses strengthen their financial structure, governance, and decision-making. With more than 10 years of experience across corporate finance, controllership, and consulting, she has built her career at global firms such as PwC and international technology companies, contributing to financial modeling, valuation, M&A, financial planning, and finance transformation projects.\n\nLuciana holds a degree in Accounting from FECAP and has completed specialization programs at the University of São Paulo (USP). Her expertise includes financial planning, budgeting, cash flow management, performance management, and internal controls. Throughout her career, she has led finance transformation and structuring initiatives, implementing processes, KPIs, and financial routines that improve forecasting, operational efficiency, and decision quality.\n\nAt Monetique, Luciana leads the company’s strategy and works directly with entrepreneurs and executives to strengthen financial governance, increase visibility into business performance, and turn financial data into decisions that support sustainable growth. Her work combines strategic leadership with hands-on financial execution for clients in Brazil and the United States.",
      image: luciana,
    },
    {
      name: "Gabrielle Doca",
      role: "Senior FP&A Manager | Executive Mentor",
      bio: "Senior FP&A Manager and Executive Mentor at Monetique, Gabrielle Doca helps businesses strengthen planning, performance management, and strategic decision-making. With more than 10 years of experience in finance and strategy, she has worked across Brazilian and multinational companies, leading initiatives in FP&A, controllership, treasury, and business partnering.\n\nGabrielle holds a degree from Mackenzie and a specialization from FGV. Her expertise includes financial planning, budgeting, performance analysis, governance, and data-driven management models. Throughout her career, she has worked on advanced financial analysis, risk policies, KPI development, and executive committee support, connecting financial insights with business priorities.\n\nAt Monetique, Gabrielle applies her experience to structure finance functions, improve processes, and strengthen performance-driven management. Her work combines analytical depth, close collaboration with leadership teams, and executive development to help Brazilian companies build more efficient operations and make more consistent strategic decisions.",
      image: gabrielle,
    },
    {
      name: "Gabriel Hildebrando",
      role: "Finance Manager",
      bio: "Finance Manager at Monetique, Gabriel Hildebrando helps businesses build strong financial operations by delivering accurate accounting records and reliable financial information to support strategic decision-making. He holds a Bachelor’s degree in Accounting from Fluminense Federal University (UFF), one of Brazil’s leading public universities, and brings six years of experience working with accounting firms in Brazil and the United States, including experience at PwC.\n\nGabriel specializes in full-cycle bookkeeping, overseeing accounts payable and receivable, reconciliations, transaction monitoring, financial close processes, and the preparation of financial and management reports. He also supports tax compliance, audit readiness, and strategic financial needs, ensuring clients have accurate, organized, and up-to-date information to confidently manage and grow their businesses.\n\nAt Monetique, Gabriel works closely with entrepreneurs and business leaders, transforming financial processes and data into clear, actionable information. Originally from Rio de Janeiro, he believes discipline, consistency, and attention to detail are essential both professionally and personally. Outside of work, he enjoys hiking, sports, and motorsports.",
      image: gabriel,
    },
  ],
  pt: [
    {
      name: "Luciana Camargo",
      role: "CEO & Fundadora | CFO Estratégica",
      bio: "CEO e fundadora da Monetique, Luciana Camargo atua como CFO estratégica, apoiando empresas na estruturação financeira, governança e tomada de decisão. Com mais de 10 anos de experiência em finanças corporativas, controladoria e consultoria, construiu sua trajetória em empresas globais, como a PwC, e em companhias internacionais de tecnologia, participando de projetos de modelagem financeira, valuation, M&A, planejamento financeiro e estruturação de operações.\n\nFormada em Ciências Contábeis pela FECAP e com especializações pela USP, possui sólida experiência em planejamento financeiro, orçamento, gestão de caixa, performance e implementação de controles internos. Ao longo da carreira, liderou projetos de estruturação e transformação de áreas financeiras, implementando processos, indicadores e rotinas que aumentam a previsibilidade, a eficiência operacional e a qualidade das decisões.\n\nNa Monetique, lidera a estratégia da empresa e atua diretamente com empreendedores e executivos, fortalecendo a governança financeira, ampliando a visibilidade dos resultados e transformando dados em decisões que sustentam o crescimento. Seu trabalho combina visão estratégica e execução financeira para apoiar clientes no Brasil e nos Estados Unidos.",
      image: luciana,
    },
    {
      name: "Gabrielle Doca",
      role: "Gerente Sênior de FP&A | Mentora Executiva",
      bio: "Gerente Sênior de FP&A e Mentora Executiva na Monetique, Gabrielle Doca atua apoiando empresas na construção de processos de planejamento, performance e tomada de decisão. Com mais de 10 anos de experiência em finanças e estratégia, construiu sua trajetória em empresas nacionais e multinacionais, liderando projetos de FP&A, controladoria, tesouraria e business partnering.\n\nGraduada pelo Mackenzie e com especialização pela FGV, possui sólida experiência em planejamento financeiro, orçamento, análise de performance, governança e desenvolvimento de modelos gerenciais orientados a dados. Ao longo da carreira, atuou em análises financeiras avançadas, políticas de risco, construção de indicadores e apoio a comitês executivos, conectando informações financeiras às prioridades estratégicas do negócio.\n\nNa Monetique, Gabrielle aplica sua experiência para estruturar áreas financeiras, aprimorar processos e fortalecer a cultura de gestão por indicadores. Sua atuação combina visão analítica, proximidade com a liderança e desenvolvimento executivo para apoiar empresas brasileiras na construção de operações mais eficientes e decisões mais consistentes.",
      image: gabrielle,
    },
    {
      name: "Gabriel Hildebrando",
      role: "Gerente Financeiro",
      bio: "Gerente Financeiro na Monetique, Gabriel Hildebrando atua apoiando empresas na organização e gestão de suas operações financeiras, garantindo informações contábeis confiáveis para uma tomada de decisão estratégica. Formado em Ciências Contábeis pela Universidade Federal Fluminense (UFF), uma das principais universidades públicas do Brasil, possui seis anos de experiência em escritórios de contabilidade no Brasil e nos Estados Unidos, além de passagem pela PwC.\n\nSua expertise está na gestão completa das rotinas financeiras e contábeis (full-cycle bookkeeping), incluindo contas a pagar e a receber, conciliações, acompanhamento de transações, fechamentos financeiros e elaboração de relatórios gerenciais e contábeis. Também oferece suporte a obrigações fiscais, auditorias e demandas financeiras estratégicas, assegurando informações atualizadas, organizadas e confiáveis para sustentar o crescimento dos clientes.\n\nNa Monetique, trabalha lado a lado com empreendedores e gestores, transformando processos e dados financeiros em informações claras e acionáveis. Natural do Rio de Janeiro, acredita que disciplina, consistência e atenção aos detalhes fazem a diferença tanto no ambiente profissional quanto na vida pessoal. Fora do trabalho, aprecia trilhas, esportes e automobilismo.",
      image: gabriel,
    },
  ],
};

export const WHAT_WE_DO = {
  en: {
    title: "What We Do",
    subtitle: "We do not just consult. We collaborate.",
    sections: [
      {
        title: "Strategic Finance & Data Performance",
        content: "We turn financial complexity into clarity. Through dashboards, analysis and scenario modelling, we help you uncover insights that move your business forward, from better forecast accuracy to clearer profit visibility and stronger financial automation.",
        image: strategicFinance,
      },
      {
        title: "Business Partnering & Executive Strategy",
        content: "Finance is not just numbers. It is the language of strategy. We partner with executives to align vision, people and performance, so leaders can make informed decisions and deliver lasting results.",
        image: businessPartner,
      },
      {
        title: "Technology & Future Finance",
        content: "Technology is rewriting the rules of business. We help organisations embrace AI, automation and cloud finance, turning digital transformation into smarter insights, seamless processes and sustainable growth.",
        image: ai,
      },
      {
        title: "Global Advisory & Expansion",
        content: "From cross border setup to multilingual mentoring, we support leaders expanding beyond borders. Our global advisory helps your business strategy, culture and numbers speak the same language wherever you operate.",
        image: globalAdvisory,
      },
    ],
  },
  pt: {
    title: "O que Fazemos",
    subtitle: "Nós não apenas consultamos, colaboramos.",
    sections: [
      {
        title: "Finanças Estratégicas & Desempenho de Dados",
        content: "Transformamos a complexidade financeira em clareza. Com dashboards, análises e modelagem de cenários, revelamos insights que impulsionam seu negócio, das previsões precisas ao acompanhamento do lucro e à automação financeira.",
        image: strategicFinance,
      },
      {
        title: "Parceria de Negócios & Estratégia Executiva",
        content: "Finanças não são apenas números, são a linguagem da estratégia. Atuamos como parceiros dos executivos para alinhar visão, pessoas e desempenho, capacitando líderes a tomar decisões informadas e gerar resultados duradouros.",
        image: businessPartner,
      },
      {
        title: "Tecnologia & Finanças do Futuro",
        content: "A tecnologia está reescrevendo as regras dos negócios. Ajudamos organizações a abraçar IA, automação e finanças em nuvem, transformando a transformação digital em insights mais inteligentes, processos contínuos e crescimento sustentável.",
        image: ai,
      },
      {
        title: "Consultoria Global & Expansão",
        content: "Desde a configuração transfronteiriça até a mentoria multilíngue, apoiamos líderes que expandem além das fronteiras. Nossa consultoria global garante que sua estratégia de negócios, cultura e números falem a mesma língua, onde quer que você opere.",
        image: globalAdvisory,
      },
    ],
  },
};


export const NavIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 40 32"
    style={{ fill: "none" }}
    aria-hidden="true"
  >
    <line className="nav-line nav-line-top" x1="7" y1="8" x2="33" y2="8" />
    <line className="nav-line nav-line-mid" x1="11" y1="16" x2="33" y2="16" />
    <line className="nav-line nav-line-bottom" x1="5" y1="24" x2="33" y2="24" />
  </svg>
);

export const WhatsAppIcon = () => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 1080 1080"
    width="24"
    height="24"
    style={{ cursor: "pointer" }}
    onClick={() => window.open("https://wa.me/5511944794757", "_blank", "noopener,noreferrer")}
  >
    <defs>
      <style type="text/css">{`.st0{fill:#fff;}.st1{fill:#013238;}`}</style>
    </defs>
    <path
      className="st0"
      d="M1069.57,540c0,292.47-237.1,529.57-529.57,529.57h0c-292.47,0-529.57-237.1-529.57-529.57h0C10.43,247.53,247.53,10.43,540,10.43h0c292.47,0,529.57,237.1,529.57,529.57h0Z"
    />
    <path
      className="st1"
      d="M538.08,200.67c-163.67,5.31-298.84,137.87-307.04,301.42-2.95,58.95,10.05,114.69,35.34,163.08l-35.53,159.12c-1.5,7.2,4.87,13.57,12.07,12.07l159.12-35.53h.11c48.05,25.11,103.21,38.11,161.73,35.4,163.29-7.56,296.27-141.72,302.59-305.07,7.15-185-143.64-336.49-328.39-330.5ZM548.67,770.78c-46.28,0-89.6-12.5-126.89-34.33-3.51-1.97-6.91-4.06-10.2-6.25l-101.66,27.09,27.09-101.66c-25.66-39.48-40.58-86.53-40.58-137.09,0-139.06,113.18-252.24,252.24-252.24s252.24,113.18,252.24,252.24-113.18,252.24-252.24,252.24Z"
    />
    <path
      className="st1"
      d="M698.27,629.58c-4.4,6.6-9.02,12.75-16.38,20.12-16.16,16.16-38.59,24.3-61.36,21.99-40.79-4.18-98.74-26.72-148.55-76.42-49.81-49.81-72.35-107.76-76.42-148.55-2.31-22.76,5.83-45.19,21.99-61.36,7.37-7.37,13.53-11.99,20.12-16.49,12.2-8.25,28.81-2.75,33.43,11.11l16.71,50.14c4.62,13.74,2.53,22.43-3.41,28.26l-13.31,13.42c-6.6,6.6-7.7,16.82-2.64,24.74,7.37,11.55,21.22,30.02,46.73,55.53,25.51,25.51,43.98,39.36,55.53,46.73,7.92,5.06,18.14,3.96,24.74-2.64l13.42-13.31c5.83-5.94,14.51-8.03,28.26-3.41l50.14,16.71c13.85,4.62,19.35,21.22,11,33.43Z"
    />
  </svg>
);

export const LinkedInIcon = () => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 1080 1080"
    width="24"
    height="24"
    style={{ cursor: "pointer" }}
    onClick={() => window.open("https://www.linkedin.com/company/monetique/", "_blank", "noopener,noreferrer")}
  >
    <defs>
      <style type="text/css">{`.st0{fill:#fff;}.st1{fill:#013238;}`}</style>
    </defs>
    <path
      className="st0"
      d="M1069.57,540c0,292.47-237.1,529.57-529.57,529.57h0c-292.47,0-529.57-237.1-529.57-529.57h0C10.43,247.53,247.53,10.43,540,10.43h0c292.47,0,529.57,237.1,529.57,529.57h0Z"
    />
    <g>
      <circle className="st1" cx="352.43" cy="330.21" r="68.21" />
      <rect className="st1" x="295.59" y="443.89" width="113.68" height="341.03" rx="1.53" ry="1.53" />
      <path
        className="st1"
        d="M795.78,568.94v193.25c0,12.5-10.23,22.74-22.74,22.74h-68.21c-12.5,0-22.74-10.23-22.74-22.74v-159.15c0-31.38-25.46-56.84-56.84-56.84s-56.84,25.46-56.84,56.84v159.15c0,12.5-10.23,22.74-22.74,22.74h-68.21c-12.5,0-22.74-10.23-22.74-22.74v-295.56c0-12.5,10.23-22.74,22.74-22.74h68.21c12.5,0,22.74,10.23,22.74,22.74v14.55c22.74-29.44,60.36-48.65,102.31-48.65,62.75,0,125.05,45.47,125.05,136.41Z"
      />
    </g>
  </svg>
);

export const InstagramIcon = () => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 1080 1080"
    width="24"
    height="24"
    style={{ cursor: "pointer" }}
    onClick={() => window.open("https://www.instagram.com/monetiquebrasil", "_blank", "noopener,noreferrer")}
  >
    <defs>
      <style type="text/css">{`.st0{fill:#fff;}.st1{fill:#013238;}`}</style>
    </defs>
    <path
      className="st0"
      d="M1069.57,540c0,292.47-237.1,529.57-529.57,529.57h0c-292.47,0-529.57-237.1-529.57-529.57h0C10.43,247.53,247.53,10.43,540,10.43h0c292.47,0,529.57,237.1,529.57,529.57h0Z"
    />
    <rect
      x="315"
      y="315"
      width="450"
      height="450"
      rx="120"
      ry="120"
      style={{ fill: "none", stroke: "#013238", strokeWidth: 38 }}
    />
    <circle
      cx="540"
      cy="540"
      r="105"
      style={{ fill: "none", stroke: "#013238", strokeWidth: 38 }}
    />
    <circle className="st1" cx="683" cy="397" r="24" />
  </svg>
);

export const YouTubeIcon = () => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 1080 1080"
    width="24"
    height="24"
    style={{ cursor: "pointer" }}
    onClick={() => window.open("https://www.youtube.com/", "_blank", "noopener,noreferrer")}
  >
    <defs>
      <style type="text/css">{`.st0{fill:#fff;}.st1{fill:#013238;}`}</style>
    </defs>
    <path
      className="st0"
      d="M1070.51,540c0,292.99-237.52,530.51-530.51,530.51h0c-292.99,0-530.51-237.52-530.51-530.51h0C9.49,247,247,9.49,540,9.49h0c292.99,0,530.51,237.52,530.51,530.51h0Z"
    />
    <path
      className="st1"
      d="M768.64,315.21h-457.25c-45.18,0-81.81,36.63-81.81,81.79v285.99c0,45.18,36.63,81.79,81.81,81.79h457.25c45.16,0,81.79-36.61,81.79-81.79v-285.99c0-45.16-36.63-81.79-81.79-81.79ZM613.45,559.73l-127.14,63.54c-14.67,7.35-31.94-3.31-31.94-19.71v-127.1c0-16.4,17.27-27.06,31.94-19.73l127.14,63.56c16.24,8.11,16.24,31.31,0,39.45Z"
    />
  </svg>
);

export const XIcon = () => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 1080 1080"
    width="24"
    height="24"
    style={{ cursor: "pointer" }}
    onClick={() => window.open("https://x.com", "_blank", "noopener,noreferrer")}
  >
    <defs>
      <style type="text/css">{`.st0{fill:#fff;}.st1{fill:#013238;}`}</style>
    </defs>
    <path
      className="st0"
      d="M1072.05,540c0,293.84-238.21,532.05-532.05,532.05h0C246.16,1072.05,7.95,833.84,7.95,540h0C7.95,246.16,246.16,7.95,540,7.95h0c293.84,0,532.05,238.21,532.05,532.05h0Z"
    />
    <path
      className="st1"
      d="M616.78,491.12l215.23-230.21h-81.74l-168.93,180.7-129.36-180.7h-223.55l226.3,316.11-226.3,242.05h81.74l180.01-192.54,137.84,192.54h223.55l-234.79-327.95ZM343.62,320.12h77.94l314.83,439.76h-77.94l-314.83-439.76Z"
    />
  </svg>
);


